export const motivosBmsPagamentosEnum = [
  {
    descricaoBMSPayment: "PIX_001",
    motivo: "Saldo Insuficiente para realizar débito na Conta Origem",
    descricaoBanco: "PIX_001"
  },
  {
    descricaoBMSPayment: "DICT_001",
    motivo: "A chave informada não existe",
    descricaoBanco: "DICT_001"
  },
  {
    descricaoBMSPayment: "DICT_002",
    motivo: "Formato da chave inválido",
    descricaoBanco: "DICT_002"
  },
  {
    descricaoBMSPayment: "DICT_429",
    motivo: "Rate limit excedido na comunicação com o Bacen (DICT)",
    descricaoBanco: "DICT_429"
  },
  {
    descricaoBMSPayment: "CREDIT_008",
    motivo: "Beneficiário não é titular da conta informada para crédito",
    descricaoBanco: "CREDIT_008"
  },
  {
    descricaoBMSPayment: "PIX_003",
    motivo: "Houve um erro ao processar transferência PIX",
    descricaoBanco: "PIX_003"
  },
  {
    descricaoBMSPayment: "PIX_004",
    motivo: "Tipo de Conta inválida para a operação",
    descricaoBanco: "PIX_004"
  },
  {
    descricaoBMSPayment: "CREDIT_002",
    motivo: "Status inválido para o contrato",
    descricaoBanco: "CREDIT_002"
  },
  {
    descricaoBMSPayment: "CREDIT_003",
    motivo: "O contrato já está com o status de pago",
    descricaoBanco: "CREDIT_003"
  },
  {
    descricaoBMSPayment: "CREDIT_004",
    motivo: "Existe Pagamento Pendente para o Contrato",
    descricaoBanco: "CREDIT_004"
  },
  {
    descricaoBMSPayment: "CREDIT_009",
    motivo: "Erro Genérico",
    descricaoBanco: "CREDIT_009"
  },
  {
    descricaoBMSPayment: "CREDIT_010",
    motivo: "Contrato está com o status de cancelado",
    descricaoBanco: "CREDIT_010"
  },
  {
    descricaoBMSPayment: "CREDIT_011",
    motivo: "Quantidade de Tentativas de Pagamento Ultrapassada",
    descricaoBanco: "CREDIT_011"
  },
  {
    descricaoBMSPayment: "CREDIT_012",
    motivo: "Averbação pendente na CEF",
    descricaoBanco: "CREDIT_012"
  },
  {
    descricaoBMSPayment: "CREDIT_013",
    motivo: "Banco não cadastrado",
    descricaoBanco: "CREDIT_013"
  },
  {
    descricaoBMSPayment: "CREDIT_014",
    motivo: "Transação já registrada",
    descricaoBanco: "CREDIT_014"
  },
  {
    descricaoBMSPayment: "CREDIT_015",
    motivo: "Situação de erro do contrato não permite cancelamento",
    descricaoBanco: "CREDIT_015"
  },
  {
    descricaoBMSPayment: "CREDIT_020",
    motivo: "Pendente de formalização na Dataprev",
    descricaoBanco: "CREDIT_020"
  },
  {
    descricaoBMSPayment: "",
    motivo: "Retorno vazio de Pagamento - BMS",
    descricaoBanco: "SEM_RETORNO_PAGAMENTO"
  }
]
